import { call, put, takeLatest } from 'redux-saga/effects';
import memberAdminNoSessionApi from 'api/employee/memberAdminNoSessionApi';
import * as alertActions from 'redux/ducks/common/alertDucks';
import * as passwordChangeForPPPActions from 'redux/ducks/passwordChangeForPPP/passwordChangeForPPPDucks';

export function* getAuthenticateCallPhone({ payload }) {
  try {
    yield put(passwordChangeForPPPActions.setRequestOtpState(false));
    yield call(memberAdminNoSessionApi.getAuthenticateCallPhone, payload);
    yield put(passwordChangeForPPPActions.setOtpSent(true));
  } catch (error) {
    yield put(passwordChangeForPPPActions.setRequestOtpState(true));
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* getAuthenticateExternalMail({ payload }) {
  try {
    yield put(passwordChangeForPPPActions.setRequestOtpState(false));
    yield call(memberAdminNoSessionApi.getAuthenticateExternalMail, payload);
    yield put(passwordChangeForPPPActions.setOtpSent(true));
  } catch (error) {
    yield put(passwordChangeForPPPActions.setRequestOtpState(true));
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* getAuthenticateAuthNum({ payload }) {
  try {
    yield call(memberAdminNoSessionApi.getAuthenticateAuthNum, {
      authnum: payload.authnum,
      fnm: payload.fnm,
      userId: payload.userId,
    });
    yield put(passwordChangeForPPPActions.getAuthenticateAuthNumSuccess());
    yield put(passwordChangeForPPPActions.resetIncorrectOTPCount());
  } catch (error) {
    yield put(passwordChangeForPPPActions.setAuthenticateAuthNumFail(error.errorCode || error.message));
  }
}

export function* modifyPassword({ payload }) {
  try {
    const response = yield call(memberAdminNoSessionApi.modifyAuthenticatePassword, {
      authnum: payload.authnum,
      userId: payload.userId,
      newPwd: payload.password.pwd,
    });
    yield put(passwordChangeForPPPActions.modifyPasswordSuccess(response));
  } catch (error) {
    yield put(passwordChangeForPPPActions.modifyPasswordFail());
    yield put(alertActions.open({ message: [error.errorCode || error.message] }));
  }
}

export default function* passwordChangeForPPPSaga() {
  yield takeLatest(passwordChangeForPPPActions.getAuthenticateCallPhone, getAuthenticateCallPhone);
  yield takeLatest(passwordChangeForPPPActions.getAuthenticateExternalMail, getAuthenticateExternalMail);
  yield takeLatest(passwordChangeForPPPActions.getAuthenticateAuthNum, getAuthenticateAuthNum);
  yield takeLatest(passwordChangeForPPPActions.modifyPassword, modifyPassword);
}
